//(function () {
//	'use strict';

//	const module = angular.module('imApp');

//	module.component('actStatuses', {
//		templateUrl: 'views/components/views/actStatuses/actStatuses.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['stateService', 'actStatusesService', function (stateService, actStatusesService) {
//            const vm = this;

//			vm.model = {
//				itemsListActStatuses: []
//			};

//            async function loadActStatuses() {
//                vm.model.itemsListActStatuses = await actStatusesService.listActStatuses();
//            }
            
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'actstatus':
//                        go({ actstatus_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };
            
//            vm.$onInit = function () {
//                loadActStatuses();
//            }
//		}]
//	});
//})();
